<template>
	<div class="analytics-status-card">
		<div class="status-head">
			<span class="status-badge" :class="badgeClass">
				<i class="fas" :class="badgeIcon"></i>
				{{ badgeText }}
			</span>
			<span class="status-title">{{ $t('geradorAnalytics') }}</span>
		</div>
		<div v-if="lastRun" class="status-body">
			<div>{{ $t('ultima_execucao') }} : {{ formattedLastRun }}</div>
			<div>{{ $t('Duracao') }}: {{ lastRun.duration_seconds }}s</div>
			<div>{{ $t('taxa_de_erro') }}: {{ formattedErrorRate }}</div>
		</div>
		<div v-else class="status-body muted">{{ $t('Sem_execucoes') }}</div>
	</div>
</template>

<script>
import GeradorAnalyticsProvider from '@/application/providers/GeradorAnalyticsProvider';

const POLL_INTERVAL_MS = 5 * 60 * 1000;

export default {
	name: 'DashboardGestaoAnalyticsStatus',
	data() {
		return {
			reachable: false,
			lastRun: null,
		};
	},
	computed: {
		badgeClass() {
			return this.reachable && this.lastRun?.success ? 'ok' : 'down';
		},
		badgeIcon() {
			return this.reachable && this.lastRun?.success ? 'fa-check-circle' : 'fa-times-circle';
		},
		badgeText() {
			if (!this.reachable) return 'Indisponível';

			if (this.lastRun?.success === true) {
				return 'Ativo';
			}

			if (this.lastRun?.success === false) {
				return 'Falha na última execução';
			}

			return 'Não executado';
		},
		formattedLastRun() {
			return this.lastRun?.last_run_at ? new Date(this.lastRun.last_run_at).toLocaleString('pt-BR') : '-';
		},
		formattedErrorRate() {
			return this.lastRun?.error_rate != null ? `${(this.lastRun.error_rate * 100).toFixed(1)}%` : '-';
		},
	},
	mounted() {
		this.fetchStatus();
		this.poll = setInterval(this.fetchStatus, POLL_INTERVAL_MS);
	},
	beforeDestroy() {
		clearInterval(this.poll);
	},
	methods: {
		fetchStatus() {
			GeradorAnalyticsProvider.getGeradorAnalyticsStatus().then(data => {
				this.reachable = !!data?.reachable;
				this.lastRun = data?.lastRun || null;
			}).catch(() => {
				this.reachable = false;
			});
		},
	},
};
</script>

<style scoped lang="less">
@card: #ffffff;
@line: #e7e9f0;
@ink: #1a2036;
@muted: #6b7280;
@green: #16a34a;
@red: #dc2626;

.analytics-status-card {
	background: @card;
	border: 1px solid @line;
	border-radius: 14px;
	padding: 16px;
	margin-bottom: 14px;

	.status-head {
		display: flex;
		align-items: center;
		gap: 10px;
	}

	.status-badge {
		padding: 3px 10px;
		border-radius: 999px;
		font-size: 12px;
		font-weight: 700;

		&.ok {
			background: #e9f8ee;
			color: @green;
		}

		&.down {
			background: #fdeceb;
			color: @red;
		}
	}

	.status-title {
		font-weight: 700;
		color: @ink;
	}

	.status-body {
		margin-top: 8px;
		font-size: 13px;
		color: @muted;

		&.muted {
			font-style: italic;
		}
	}
}
</style>
